<!--
  @deprecated Usar PresentationSalaView.vue en su lugar.
  Reemplazada por /presentation/sala/:idSala.
  Sin enlaces activos en la app. Se mantiene por compatibilidad.
-->
<template>
  <SlideShow
    v-show="diapos.length > 0"
    :diapositivas="diapos"
    :idVetlla="idVetlla"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, toRef } from "vue";
import axios from "axios";
import { Vetlla, Diapositiva } from "../types/vetlla.ts";
import SlideShow from "../components/SlideShow.vue";

export default defineComponent({
  components: { SlideShow },
  props: {
    idVetlla: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const diapos = ref<Diapositiva[]>([]);
    const idVetllaRef = toRef(props, "idVetlla");

    const updateDiapos = async () => {
      const response = await axios.get(`/api/vetlla/read?id=${props.idVetlla}`);
      const vetlla = response.data as Vetlla;
      const noves = [
        {
          Id: -1,
          PathFoto: "",
          Missatge: vetlla.NombreDifunto,
          Signatura: "",
          IsVisible: true,
        },
        ...vetlla.Diapositivas.filter((d) => d.IsVisible),
      ];
      diapos.value = noves;
    };

    onMounted(() => {
      updateDiapos();
      setInterval(updateDiapos, 5000);
    });

    watch(idVetllaRef, (newId, oldId) => {
      if (newId !== oldId) {
        updateDiapos();
      }
    });

    return {
      diapos,
    };
  },
});
</script>
